module.exports = __webpack_public_path__ + "img/top-logo.2f7981a2.png";